import PosLandingBrand from './PosLandingBrand';
import { APP_VERSION_NO } from '../constants/bookingConst';
import {
  LANDING_CONTACT_EMAIL, LANDING_COPYRIGHT, LANDING_SECTIONS,
} from '../constants/posLandingConst';

/**
 * The page footer: brand, section links, copyright, contact address and, on
 * the far right, the build's version (hidden when REACT_APP_VERSION_NO is
 * not set).
 *
 * @returns {JSX.Element}
 */
function PosLandingFooter() {
  return (
    <footer>
      <div className="wrap">
        <div className="foot">
          <PosLandingBrand suffixStyle={{ color: 'var(--mint)' }} />
          <nav>
            <a href={`#${LANDING_SECTIONS.work}`}>See it work</a>
            <a href={`#${LANDING_SECTIONS.pricing}`}>Pricing</a>
            <a href={`#${LANDING_SECTIONS.faq}`}>Questions</a>
            <a href={`#${LANDING_SECTIONS.till}`}>Open your till</a>
          </nav>
        </div>
        <div className="foot-btm">
          <span>{LANDING_COPYRIGHT}</span>
          {/* Email and version share the right-hand slot, so the existing
              left/right split of the bottom row is unchanged. */}
          <span className="foot-end">
            <span>{LANDING_CONTACT_EMAIL}</span>
            {APP_VERSION_NO && <span className="foot-version">{APP_VERSION_NO}</span>}
          </span>
        </div>
      </div>
    </footer>
  );
}

export default PosLandingFooter;
